<div class="ui-segmented-filter" role="group" [attr.aria-label]="label()">
  @for (option of options(); track option.value) {
    <button
      type="button"
      class="ui-segmented-filter__option"
      [class.ui-segmented-filter__option--active]="option.value === value()"
      [attr.aria-pressed]="option.value === value()"
      [disabled]="option.disabled"
      (click)="select(option)"
    >
      {{ option.label }}
    </button>
  }
</div>
